import React, { useEffect, useRef, useState, useMemo } from "react";
import { ThumbGroup } from "@/stores/clip/class/ThumbTrack";

interface ThumbItemProps {
  trackItem: ThumbGroup;
  itemIndex: number;
}

const ThumbItem: React.FC<ThumbItemProps> = ({ trackItem }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log(trackItem.materials);
  }, []);

  return (
    <div
      className="thumb-group"
      style={{
        overflow: "hidden",
        borderRadius: 6,
        height: "100%",
      }}
      ref={containerRef}
    >
      <img
        src={trackItem.materials[0]?.url}
        style={{ pointerEvents: "none", height: "100%" }}
      />
    </div>
  );
};

export default ThumbItem;
